import React from "react";
import { useParams } from "react-router-dom";
import ReportRoutes from "../report/report_routes";

const NetworkReportRoutes = () => {
  const { networkId } = useParams();
  return <ReportRoutes isHub={false} basePathPrefix={`/app/network/${networkId}/results`} />;
};

export default NetworkReportRoutes;
